var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('navbar',{attrs:{"title":"Portfolio 2016","links":_vm.links}},[_c('li',[_c('nn-btn',{attrs:{"nn-text":"Dig","nn-color":"gold-tips","nn-active":_vm.theme === 'earthquake'},on:{"click":function($event){return _vm.$store.commit('toggleTheme', {
          name: 'theme2016',
          value: 'earthquake',
        })}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }